import type {Editor} from "slate";

/**
 * This is a Slate plugin that adds support for skeleton block elements.
 */
export const withSkeletons = (editor: Editor): Editor => {
    const {isBlock, isVoid, isSelectable} = editor;

    editor.isBlock = (element) =>
        element.type === "skeleton-block" || isBlock(element);

    editor.isVoid = (element) =>
        element.type === "skeleton-block" || isVoid(element);

    editor.isSelectable = (element) =>
        element.type === "skeleton-block" ? false : isSelectable(element);

    return editor;
};
